import SpecimenAdditionalInfoService from './specimen-additional-info.service';
import CaseSpecimenTransactionService from './case-specimen-transaction.service';
import MethodOfCollectionService from './method-of-collection.service';
import SpecimenStateService from './specimen-state.service';
import SpecimenTypeService from './specimen-type.service';
import CaseSpecimenService from './case-specimen.service';
import BoxTypeService from './box-type.service';
import FreezerService from './freezer.service';
import CaseService from './case.service';
import BoxService from './box.service';

export default {
  biobankRegistry: ({ axios }) => ({
    specimenAdditionalInfoService: new SpecimenAdditionalInfoService({ axios }),
    caseSpecimenTransactionService: new CaseSpecimenTransactionService({ axios }),
    methodOfCollectionService: new MethodOfCollectionService({ axios }),
    specimenStateService: new SpecimenStateService({ axios }),
    specimenTypeService: new SpecimenTypeService({ axios }),
    caseSpecimenService: new CaseSpecimenService({ axios }),
    freezerService: new FreezerService({ axios }),
    boxTypeService: new BoxTypeService({ axios }),
    caseService: new CaseService({ axios }),
    boxService: new BoxService({ axios }),
  }),
};
